import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, RadioChangeEvent, Row, Select, Space } from "antd";

import AddressMaker, { AddressType } from "./AddressMaker";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterOption({ editMode, option, onRegisterOption }: { editMode: string; option?: Types.OptionDto; onRegisterOption?: () => void }) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [optionId, setOptionId] = useState("");
    const [optionName, setOptionName] = useState("");
    const [price, setOptionPrice] = useState("");

    const requestAxiosAddOption = async (data: Types.OptionDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().post(Request.OPTION_URL, data);

        return response.data;
    };

    const {
        loading: loadingAddOption,
        error: errorAddOption,
        data: resultAddOption,
        execute: requestAddOption,
    } = useAsyncAxios(requestAxiosAddOption);

    useEffect(() => {
        if (option === undefined) return;

        form.setFieldsValue(option);
    }, [option]);

    useEffect(() => {
        if (resultAddOption === null) return;

        if (onRegisterOption) onRegisterOption();

        alert.setAlert(AlertType.SUCCESS, "옵션 추가 성공", "옵션 추가를 완료하였습니다.");
    }, [resultAddOption]);

    useEffect(() => {
        if (errorAddOption === null) return;

        console.log("errorOption", errorAddOption);
        alert.setAlert(errorAddOption.response.data.code, "옵션 추가 실패", errorAddOption.response.data.message);
    }, [errorAddOption]);

    const requestAxiosUpdateOption = async (data: Types.OptionDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().put(Request.OPTION_URL + "/" + data.optionId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateOption,
        error: errorUpdateOption,
        data: resultUpdateOption,
        execute: requestUpdateOption,
    } = useAsyncAxios(requestAxiosUpdateOption);

    useEffect(() => {
        if (resultUpdateOption === null) return;

        if (onRegisterOption) onRegisterOption();

        alert.setAlert(AlertType.SUCCESS, "옵션 수정 성공", "옵션 수정을 완료하였습니다.");
    }, [resultUpdateOption]);

    useEffect(() => {
        if (errorUpdateOption === null) return;

        console.log("errorUpdateOption", errorUpdateOption);
        alert.setAlert(errorUpdateOption.response.data.code, "옵션 수정 실패", errorUpdateOption.response.data.message);
    }, [errorUpdateOption]);

    const onFinish = (values: any) => {
        delete values["confirm"];
        const data: Types.OptionDto = {
            ...values,
        };
        console.log("Received values of form: ", data);

        if (editMode === "add") requestAddOption(data);
        else if (editMode === "update") requestUpdateOption(data);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="optionId" label="옵션 ID">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="price"
                                label="가격"
                                rules={[
                                    {
                                        required: true,
                                        message: "가격을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="가격을 입력해 주세요." onChange={(e) => setOptionPrice(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="optionName"
                                label="옵션 이름"
                                rules={[
                                    {
                                        required: true,
                                        message: "옵션 이름을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="옵션 이름을 입력해 주세요." onChange={(e) => setOptionName(e.target.value)} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterOption;
